export default{
  APIendpoint:"https://dashboard.genesys.sn/admin/server/reporting/"
}